import React, { useState, useEffect } from 'react';
import { Box, Text, InputGroup, InputLeftElement, Input } from '@chakra-ui/react';
import { UgcRateRange } from '@foodfluence/shared';
import { getUgcRateDisplayName } from '../../../utils/contentUtils';
import ModalShell from '../../../components/ui/ModalShell';
import { Pill } from '../../../components/ui';
import { ff } from '../../../theme';

interface UgcRate extends UgcRateRange {
  id: string;
}

interface EditRateModalProps {
  isOpen: boolean;
  onClose: () => void;
  rate: UgcRate | null;
  onSave: (id: string, price: number) => void;
}

const EditRateModal: React.FC<EditRateModalProps> = ({
  isOpen,
  onClose,
  rate,
  onSave,
}) => {
  const [priceInput, setPriceInput] = useState('');

  useEffect(() => {
    if (rate !== null) {
      setPriceInput(String(rate.minRate));
    } else {
      setPriceInput('');
    }
  }, [rate]);

  const handleClose = () => {
    setPriceInput('');
    onClose();
  };

  const handleSubmit = () => {
    if (!rate) return;
    const price = Number(priceInput);
    if (Number.isNaN(price) || price < 0) return;
    onSave(rate.id, price);
    setPriceInput('');
  };

  const canSave =
    rate !== null &&
    priceInput !== '' &&
    Number(priceInput) >= 0 &&
    Number(priceInput) !== rate?.minRate;

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={handleClose}
      title="Edit rate"
      cancelLabel="Cancel"
      primary={{ label: 'Save', onClick: handleSubmit, tone: 'lime', isDisabled: !canSave }}
    >
      <Text textStyle="eyebrow" color={ff.text2} mb={3}>
        Type
      </Text>
      <Box display="flex" mb={6}>
        <Pill tone="grey">{rate ? getUgcRateDisplayName(rate) : ''}</Pill>
      </Box>

      <Text textStyle="eyebrow" color={ff.text2} mb={3}>
        Price
      </Text>
      <InputGroup>
        <InputLeftElement pointerEvents="none" h="48px">
          <Text color={ff.text2} fontWeight={600} fontSize="17px">$</Text>
        </InputLeftElement>
        <Input
          type="number"
          min={0}
          step={1}
          value={priceInput}
          onChange={(e) => setPriceInput(e.target.value)}
          fontSize="17px"
          fontWeight={500}
        />
      </InputGroup>
    </ModalShell>
  );
};

export default EditRateModal;
